export default "__VITE_ASSET__9d99d16a__"